import React from 'react'
import {Box, CircularProgress, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

export interface LoadingViewProps {
  message?: string
  'data-test-id'?: string
}

/**
 * Generic loading view component.
 * Shows a spinner and optional message while content is loading.
 */
export const LoadingView: React.FC<LoadingViewProps> = ({
  message,
  'data-test-id': testId = 'loading-view'
}) => {
  const {t} = useTranslation()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        gap: '16px'
      }}
      data-test-id={testId}
    >
      <CircularProgress />
      <Typography variant="body1" color="text.secondary">
        {message ?? t('orderIntake.rmc.orderManagement.loading', 'Loading...')}
      </Typography>
    </Box>
  )
}
